import { Root } from "@radix-ui/react-radio-group"
import clsx from "clsx"
import { Children, ReactElement, cloneElement, isValidElement } from "react"

import styles from "./RadioGroup.module.scss"
import { RadioGroupProps } from "./RadioGroup.types"

export default function RadioGroup(props: RadioGroupProps) {
    const { children, alignment, isDisabled, className, isHorizontal, ...rest } = props

    return (
        <Root
            className={clsx(styles.base, className, { [styles.horizontal]: isHorizontal })}
            disabled={isDisabled}
            {...rest}
        >
            {Children.map(children, (child) => {
                if (isValidElement(child)) {
                    return cloneElement(child as ReactElement, {
                        ...child.props,
                        isDisabled: isDisabled || child.props.isDisabled,
                        alignment: alignment ?? child.props.alignment,
                    })
                }
                return child
            })}
        </Root>
    )
}
